module.exports = __webpack_public_path__ + "img/ebook-taaze.206cbcae.png";